"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tabs = void 0;
var _react = _interopRequireDefault(require("react"));
var RadixTabs = _interopRequireWildcard(require("@radix-ui/react-tabs"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _TabsModule = _interopRequireDefault(require("./Tabs.module.css"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cx = _bind.default.bind(_TabsModule.default);
var Tabs = _ref => {
  var defaultValue = _ref.defaultValue,
    tabs = _ref.tabs;
  return /*#__PURE__*/_react.default.createElement(RadixTabs.Root, {
    className: _TabsModule.default.Container,
    defaultValue: defaultValue || tabs[0].text
  }, /*#__PURE__*/_react.default.createElement(RadixTabs.List, {
    className: _TabsModule.default.List
  }, tabs.map(t => /*#__PURE__*/_react.default.createElement(RadixTabs.Trigger, {
    key: t.text,
    value: t.text,
    className: cx(_TabsModule.default.Tab, {
      Selected: defaultValue === t.text
    })
  }, t.text))), /*#__PURE__*/_react.default.createElement("div", null, tabs.map(t => /*#__PURE__*/_react.default.createElement(RadixTabs.Content, {
    key: t.text,
    value: t.text
  }, t.content))));
};
exports.Tabs = Tabs;
//# sourceMappingURL=Tabs.js.map